import React from "react";
import { renderToStaticMarkup } from "react-dom/server";

import ReceiptTemplate from "../components/till/ReceiptTemplate";
import useCustomerDetails from "../data/useCustomerDetails";
import { ITillReceipt } from "../models/till/ITillReceipt";
import printHtml from "../utils/printHtml";

/** Renders a receipt for 80mm paper and sends it to the browser's print dialog. */
export default function useReceiptPrinter() {
  const { brand } = useCustomerDetails();

  const printReceipt = (receipt: ITillReceipt, operatorName?: string) => {
    const html =
      "<!doctype html>" +
      renderToStaticMarkup(
        React.createElement(ReceiptTemplate, {
          receipt: { ...receipt, operatorName: receipt.operatorName ?? operatorName ?? null },
          logoSrc: brand.data?.data?.croppedLogo ?? brand.data?.data?.logo,
        })
      );

    printHtml(html);
  };

  return { printReceipt };
}
